import React, { useEffect, useState } from 'react';
import Slider from '../../../../commons/components/Slider';
import PhotoSelector from '../../../../commons/components/Forms/PhotoSelector';
import CheckboxComponent from '../../../../commons/components/Forms/CheckboxComponent';
import {STEPS} from '../../../../commons/constans/stepVideo';
import { useDispatch, useSelector } from 'react-redux';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import { isChrome } from 'react-device-detect';
import { useCharacterDetail } from '../../../../commons/customHooks/Character';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';

type Props = {
  pushDataVideoStepOne: Function,
  pushDataVideoStepTwo: Function,
  steps: Object,
  goToSteps: Function,
  character: Object,
};

const Step1Component = ({
  pushDataVideoStepOne,
  pushDataVideoStepTwo,
  steps,
  goToSteps,
  character,
}: Props) => {
  const dispatch = useDispatch();
  const [dataStep1, setDataStep1] = useState({ step_1: {} });
  const [disableBtn, setDisableBtn] = useState(true);
  const [paramCharacter, setParamCharacter] = useState({
    id: null,
    relation: 'models',
  });
  const [characterDetail, isProcessingDetail] = useCharacterDetail(paramCharacter);
  
  useEffect(() => {
    scrollTo(0, 0);
  }, []);

  useEffect(() => {
    console.log(39, character);
    if (character && character.length > 0) {
      let {step_1} = steps;
      setParamCharacter({
        ...paramCharacter,
        id: step_1?.character_id ? step_1?.character_id : character[0]?.id,
        character_pose_img: steps?.step_1?.character_pose_img ?? character[0]?.models?.[0]?.pose_image_url?.thumbnail,
      });
    }
  }, [character]);

  console.log(process.env.NODE_ENV, 'process.env.NODE_ENV');
  useEffect(() => {
    if (characterDetail && characterDetail?.models) {
      let {step_1} = steps;
      let flag = characterDetail?.models.find(element => element.id == step_1.character_pose_id);
      console.log(57, flag);
      console.log(58, characterDetail?.models, step_1.character_pose_id);
      setDataStep1({
        ...dataStep1,
        step_1: {
          ...dataStep1.step_1,
          character_name: characterDetail?.name || '',
          character_id: flag?.character_id ?? characterDetail?.id,
          character_pose_id: flag?.id ?? characterDetail?.models?.[0]?.id,
          character_pose_name: flag?.pose_name ?? characterDetail?.models?.[0]?.pose_name,
          character_pose_img: flag?.pose_image_url ?? characterDetail?.models?.[0]?.pose_image_url?.thumbnail,
        },
      });
    }
  }, [characterDetail]);

  useEffect(() => {
    setDataStep1({
      ...dataStep1,
      step_1: {
        ...dataStep1.step_1,
        character_id: paramCharacter.id,
      },
    });

  }, [paramCharacter])

  const handleSelectCharacter = (e, value) => {
    let {step_1, step_2} = steps;
    if (step_1?.character_id && (+e.target.value !== +step_1.character_id)) {
      console.log(82, +e.target.value, +step_1?.character_id);
      pushDataVideoStepTwo({
        step_2: {
          ...step_2,
          content: "",
          contentShow: "",
          content_template_id: "",
          name_template: "",
          code: "",
          child_name: "",
          title: "",
        },
      }, STEPS.TWO);
      setParamCharacter({
        ...paramCharacter,
        id: e.target.value,
      });
    }

  };

  const handleSelectCharacterPose = (e, value, data) => {
    setDataStep1({
      ...dataStep1,
      step_1: {
        ...dataStep1.step_1,
        [e.target.name]: e.target.checked ? e.target.value : '',
        character_pose_name: data?.pose_name || '',
        character_pose_img: data?.pose_image_url?.medium || '',
      },
    });
  };

  useEffect(() => {
    pushDataVideoStepOne(dataStep1, STEPS.ONE);
  }, [dataStep1]);

  const goToStep = (step) => {
    goToSteps(step);
  };

  const handleChangeCheckBox = (e) => {
    setDisableBtn(!disableBtn);
    setDataStep1({
      ...dataStep1,
      step_1: {
        ...dataStep1.step_1,
        [e.target.name]: e.target.checked,
      },
    });
  };

  const renderCharacter = () => {
    if (character && character.length > 0) {
      return character.map((item, idx) => {
        return (
          <div className="item-character" key={idx}>
            <div className={`img`}>
              <PhotoSelector
                id={`character-${item?.id || null}`}
                name={`character_id`}
                value={item?.id || null}
                attrName={item?.name}
                path={item?.featured_image_url?.thumbnail || ''}
                style={false}
                mutiple={false}
                checked={item.id == steps.step_1?.character_id}
                state={item.state}
                customClass={item.status === 'COMING_SOON' ? 'img-comimg__soon border-active' : 'border-active'}
                disabled={item.status === 'COMING_SOON' ? true : false}
                marker={false}
                handleChange={handleSelectCharacter}
              />
            </div>
            <div className="description">
              <h4>{item?.name || ''}</h4>
              <p>캐릭터 수 {item?.models?.length || 0}종</p>
            </div>
          </div>
        );
      });
    }
  };

  const renderCharacterModels = () => {
    if (
      characterDetail &&
      characterDetail.models &&
      characterDetail.models.length > 0
    ) {
      return characterDetail.models.map((models) => {
        return (
          <div className="item" key={models.id}>
            <div
              className={`img ${
                models.state === 'disable' ? 'img-comimg__soon' : ''
              }`}
            >
              <PhotoSelector
                id={`js-${models.id}`}
                name={`character_pose_id`}
                value={models?.id || null}
                path={models?.pose_image_url?.thumbnail || ''}
                style={false}
                data={models}
                checked={models.id == steps.step_1?.character_pose_id}
                handleChange={handleSelectCharacterPose}
                mutiple={false}
                marker={false}
                customClass={`character-pose-items`}
              />
            </div>
            <div className="description">
              <h4>{models?.pose_name || ''}</h4>
            </div>
          </div>
        );
      });
    }
  };

  const renderInfoCharacter = () => {
    return (
      <div className="box">
        <div className='row'>
          <div className="col-6">
          <span>선택한 캐릭터 그룹</span>
          </div>
          <div className="col-6 text-character-right">
          <strong>{steps.step_1?.character_name || ''}</strong>
          </div>
        </div>
        <div className='row'>
          <div className="col-6">
          <span>선택한 캐릭터명</span>
          </div>
          <div className="col-6 text-character-right">
          <strong>{steps.step_1?.character_pose_name || ''}</strong>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <h3>
        원하는 <span>캐릭터를 선택</span>하세요!
      </h3>
      <div className="step-slider">
        <div className="step-slider__square">
          <Slider
            slidesPerView={2.6}
            spaceBetween={10}
            pagination={false}
            delay={99999}
            classSlider="swiper-pagination__none"
          >
            {renderCharacter()}
          </Slider>
        </div>

        <div className="step-slider__ground">
          {isProcessingDetail ? (
            <>
            <Slider
                slidesPerView={4.4}
                spaceBetween={13}
                pagination={false}
                delay={99999}
                classSlider="swiper-pagination__none"
              >
              <label className="photo-selector">
                <div className="photo-selector__thumb">
                  <SkeletonLoadingComponent
                    circle={true}
                    height="100%"
                    cssClass={`avatar-skeleton photo-loading`}
                  />
                  <SkeletonLoadingComponent width={70} />
                </div>
              </label>
              <label className="photo-selector">
                <div className="photo-selector__thumb">
                  <SkeletonLoadingComponent
                    circle={true}
                    height="100%"
                    cssClass={`avatar-skeleton photo-loading`}
                  />
                  <SkeletonLoadingComponent width={70} />
                </div>
              </label>
              <label className="photo-selector">
                <div className="photo-selector__thumb">
                  <SkeletonLoadingComponent
                    circle={true}
                    height="100%"
                    cssClass={`avatar-skeleton photo-loading`}
                  />
                  <SkeletonLoadingComponent width={70} />
                </div>
              </label>
            </Slider>
            </>
          ) : (
            <>
              <Slider
                slidesPerView={4.5}
                spaceBetween={13}
                pagination={false}
                delay={99999}
                classSlider="swiper-pagination__none"
              >
                {renderCharacterModels()}
              </Slider>
            </>
          )}
        </div>
      </div>
      <div className="step-box__comment">
        {renderInfoCharacter()}

        <div className="box-checkbox">
          <CheckboxComponent
            id={'js-confirm-step-1'}
            name={'confirm_step_1'}
            value={dataStep1.step_1.confirm_step_1}
            disabled={false}
            subTitle={'선택하신 캐릭터 정보가 맞나요?'}
            labelClass={'d-flex align-start'}
            checked={steps.step_1.confirm_step_1 == true ? true : false}
            handleChange={handleChangeCheckBox}
          />
        </div>
        <div className="button">
          <ButtonComponent
            label={`다음 단계`}
            customClass="btn btn-default"
            handleClick={() => goToStep(STEPS.TWO)}
            type={`button`}
            disabled={steps.step_1.confirm_step_1 == true && !isProcessingDetail ? false : true}
          />
        </div>
      </div>
    </>
  );
};

export default Step1Component;
